let tokenExpiryTimer: ReturnType<typeof setTimeout> | null = null;

export const clearAuthAndRedirect = () => {
  if (tokenExpiryTimer) {
    clearTimeout(tokenExpiryTimer);
    tokenExpiryTimer = null;
  }

  localStorage.clear();
  sessionStorage.clear();

  window.location.replace('/');
};

export const registerTokenExpiryTimer = (token: string | null) => {
  console.log('Registering token expiry timer for token:', token);
  if (!token) {
    return;
  }

  // Clear any existing timer before registering a new one
  if (tokenExpiryTimer) {
    clearTimeout(tokenExpiryTimer);
    tokenExpiryTimer = null;
  }

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    console.log('Token payload:', payload);
    if (!payload.exp) {
      console.warn('Token does not contain an expiry time');
      return;
    }

    // JWT exp is in seconds, Date.now() is in milliseconds
    const expiryTime = payload.exp * 1000;
    const remainingTime = expiryTime - Date.now();
    console.log(`Token expiry time: ${expiryTime}`);
    console.log(`Current time: ${Date.now()}`);
    console.log(`Remaining time: ${remainingTime}`);
    if (remainingTime <= 0) {
      clearAuthAndRedirect();
      return;
    }

    console.log(`Token expires in ${Math.round(remainingTime / 1000)} seconds`);

    tokenExpiryTimer = setTimeout(() => {
      const currentToken = localStorage.getItem('userToken');

      if (!currentToken) {
        clearAuthAndRedirect();
        return;
      }

      try {
        const currentPayload = JSON.parse(atob(currentToken.split('.')[1]));

        if (!currentPayload.exp) {
          clearAuthAndRedirect();
          return;
        }

        const currentExpiry = currentPayload.exp * 1000;

        if (currentExpiry <= Date.now()) {
          clearAuthAndRedirect();
        } else {
          // Token was refreshed, register a new timer
          registerTokenExpiryTimer(currentToken);
        }
      } catch {
        clearAuthAndRedirect();
      }
    }, remainingTime);
  } catch {
    clearAuthAndRedirect();
  }
};
